import * as Sentry from '@sentry/remix';

import type { ToastData } from '~/hooks/useToast';
import type { SignupFlow } from '~/interfaces/signup_flow';
import { safeJsonParse } from '~/utils/safeJsonParse';

interface Props {
  formData: FormData;
}

export const createPaidSubscription = async ({ formData }: Props) => {
  try {
    const response = await fetch('/create_paid_subscription', {
      method: 'POST',
      headers: { 'Sec-Fetch-Dest': 'empty' },
      body: formData,
    });
    return await safeJsonParse<{
      object?: 'setup_intent' | 'payment_intent';
      action?: string;
      clientSecret?: string;
      signupFlow?: SignupFlow;
      redirectToSSOLogin?: boolean;
      toast?: ToastData;
    }>(response);
  } catch (error) {
    Sentry.captureException(error);
    return null;
  }
};
